<template>
  <div class="home" ref="homeRef">
    <div class="homebg">
      <img src="@/assets/images/home/bg.jpg" alt="" srcset="">
    </div>
    <Header ref="height0" :color="true" :bannerBg="2" />
    <div class="paddingBox">
      <div class="bannerContent" ref="height1">
        <Banner />
      </div>
      <div class="cardList">
        <div class="cardItem" v-for="(card, index) in cards" :key="index" @click="navigateTo(card.route)">
          <img class="cardBg" :src="card.image" alt="" />
          <div class="info">
            <div class="tagsHome">
              <img :src="card.icon" alt="" />
            </div>
            <div class="txt">
              <p class="t1 __line1">{{ card.title }}</p>
              <p class="t2 __line2">{{ card.subtitle }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div style="width:100%;height:76px"></div>
    <tabBar></tabBar>
  </div>
</template>

<script>
import { Toast } from "vant";
import Crypt from "@bluedot-tech/vue-ui/es/utils/crypt";
import config from "../config/config";
import Header from "@/components/header";
import Banner from "@/components/home/banner";
import tabBar from "@/components/tabBar.vue";
export default {
  components: {
    Header,
    Banner,
    tabBar
  },
  data() {
    return {
      emptyHeight: 0,
      isShowFlag: false,

      value: "",
      searchValue: "", // 父组件维护的搜索关键词
      cards: [
        {
          title: "产品中心",
          subtitle: "Product",
          image: require("@/assets/images/home/card1.png"),
          icon: require("@/assets/images/home/icon1.png"),
          route: "/childList"
        },
        {
          title: "解决方案",
          subtitle: "Solution",
          image: require("@/assets/images/home/card2.png"),
          icon: require("@/assets/images/home/icon2.png"),
          route: "/solution"
        },
        {
          title: "成功案例",
          subtitle: "Cases",
          image: require("@/assets/images/home/card3.png"),
          icon: require("@/assets/images/home/icon3.png"),
          route: "/case"
        },
        {
          title: "离型知识",
          subtitle: "Know-how",
          image: require("@/assets/images/home/card4.png"),
          icon: require("@/assets/images/home/icon4.png"),
          route: "/faq"
        }
      ]
    };
  },
  mounted() {
    // 页面浏览 监测
    this.$dataStatistics({
      page_title: "首页",
    },'首页');
    this.initShare();

    // 环境变量获取方法
    console.log("process.env", process.env);

  },

  methods: {

    navigateTo(route) {
      this.$dataStatistics('click', '首页' + route);
      this.$router.push(route);
    },

    updateTabHandle({ type }) {
      this.curType = type;
      this.reset();
    },

  },
};
</script>

<style lang="less" scoped>
.tabBox {
  z-index: 2;
  position: sticky;
  top: 128px;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  .emptyImg {
    width: 120px;
    height: 144px;
    display: block;
  }
}

.home {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;

  .paddingBox {
    padding: 0 12px;
  }

  .listCard {
    margin-top: 30px;
  }

  .bannerContent {
    width: 100%;
    height: 200px;
    margin: 0 auto 42px;
  }

  .bg {
    width: 200px;
    height: 200px;
    background-size: 100% 100%;
  }
}

.cardList {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;

  .cardItem {
    position: relative;
    width: 169px;
    height: 120px;
    background: #FAFAFA;
    border-radius: 8px;
    margin-bottom: 13px;
  }

  .cardBg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
}

.info {
  position: absolute;
  top: 42px;
  z-index: 1;
  padding: 0 17px;


  .tagsHome {
    height: 22px;
    width: 22px;
    display: inline-block;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .txt {
    .t1 {
      font-size: 16px;
      color: #FFFFFF;
      font-weight: bold;
    }

    .t2 {
      font-size: 12px;
      color: #F3F3F3;
      // margin-top: 6px;
    }
  }
}

.homebg {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

}
</style>